import React from "react";
import { css } from "glamor";
import TipTapViewer from "../../library/TipTapViewer";
import { spacing } from "../../library/theme";

const containerClass = css({
  display: "flex",
  flexDirection: "column",
  gap: 10,
});

const entryClass = css({
  border: "0.66px solid #e2e8f0",
  borderRadius: 12,
  padding: "10px 12px",
  background: "#ffffff",
  display: "flex",
  flexDirection: "column",
  gap: 4,
});

const stepHeaderClass = css({
  display: "flex",
  alignItems: "center",
  gap: 6,
  fontSize: 10,
  fontWeight: 600,
  color: "#475569",
});

const stepIndicatorClass = css({
  width: 16,
  height: 16,
  borderRadius: "50%",
  background: "#f1f5f9",
  color: "#64748b",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 8,
  fontWeight: 700,
});

const stepIndicatorCorrectClass = css({
  background: "#bbf7d0",
  color: "#166534",
});

const stepIndicatorIncorrectClass = css({
  background: "#fecaca",
  color: "#991b1b",
});

const promptTextClass = css({
  fontSize: 12,
  lineHeight: "18px",
  color: "#1e293b",
});

const answerTextClass = css({
  fontSize: 11,
  lineHeight: "17px",
  color: "#475569",
  borderTop: "1px solid #e2e8f0",
  marginTop: spacing.xs,
  paddingTop: spacing.xs,
});

const answerTextCorrectClass = css({
  color: "#166534",
});

const answerTextIncorrectClass = css({
  color: "#991b1b",
});

export default function ConversationRecap({
  entries = [],
  revealResult = false,
}) {
  if (entries.length === 0) return null;

  return (
    <div className={containerClass}>
      {entries.map(({ prompt, answer, selectedAlternative, isCorrect }, index) => {
        const indicatorModifier = revealResult && answer
          ? isCorrect
            ? stepIndicatorCorrectClass
            : stepIndicatorIncorrectClass
          : null;
        const answerModifier = revealResult && answer
          ? isCorrect
            ? answerTextCorrectClass
            : answerTextIncorrectClass
          : null;

        return (
          <div key={prompt?.id || index} className={entryClass}>
            <div className={stepHeaderClass}>
              <span className={css(stepIndicatorClass, indicatorModifier)}>
                {index + 1}
              </span>
              <span>Etapa {index + 1}</span>
            </div>
            <TipTapViewer content={prompt?.content} className={promptTextClass} />
            {selectedAlternative && (
              <TipTapViewer
                content={selectedAlternative?.content}
                className={css(answerTextClass, answerModifier)}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
